import { OrderType } from "@/constants";
import { request } from "@/utils/request";
import { N } from "mockjs";

// 获取加密货币信息
export const businessGetAccountInfo = (data:{type: string}) =>
request({
    url: "/Api/User/Business/getAccountInfo",
    method: "POST",
    data,
  });

  
// 获取 区块交易汇率 (非商家) type: IN（区块链购币 USDT购买V币） OUT （区块链卖币） V币兑换USDT
export const getRateInfoAPI = (data:{type: string}) =>
  request({
      url: "/Api/User/Business/getRateInfo",
      method: "POST",
      data,
    });


// /Api/User/Business/getDepositDetail 商家充值详情
export const getDepositDetail = (data:any) =>
request({
  url: "/Api/User/Business/getDepositDetail",
  method: "POST",
  data,
});

// 商家充值接口

type businessDepositParams = {
  paymentType?: string;//USDT
  amount: string; //123.00
  passageType: string; //TronDeposit
  receivingAddress?: string;// TQ5J7XnGEuK4c1iP3exu1moVK6fZxJurvD
  securePassword: string;//123456
}


export const businessDeposit = (data:businessDepositParams) =>
request({
    url: "/Api/User/Business/businessDeposit",
    method: "POST",
    data,
  });

// 发起V币兑换USDT订单  区块链卖币
export const businessChange = (data:businessDepositParams) =>
  request({
      url: "/Api/User/Business/businessChange",
      method: "POST",
      data,
  });
  


  type ApplyBusinessParams = {
    securePassword: string;//123456
  }
  export const applyBusiness = (data:ApplyBusinessParams) =>
  request({
    url: "/Api/User/Business/applyBusiness",
    method: "POST",
    data,
  });

  // /Api/User/Business/getUserInfo 获取商家信息

export const getBusinessUserInfo = () =>
request({
  url: "/Api/User/Business/getUserInfo",
  method: "POST",
});

// 获取商家补贴配置信息
export const getBusinessConfig = () =>
request({
    url: "/Api/User/Business/getBusinessConfig",
    method: "GET",
  });

// 获取超级商家补贴配置信息
export const getProfessionBusinessConfig = () =>
  request({
      url: "/Api/User/Business/getProfessionBusinessConfig",
      method: "GET",
    });

// /Api/User/Business/marginInrerest 商家保证金领取

export const marginInrerest = ( ) =>
request({
  url: "/Api/User/Business/marginInrerest",
  method: "POST",
});

// /Api/Market/BusinessPendingOrder/myPendingOrderList 我的挂单列表
type Params = {
  inProgress?: number;
  status?:number,
  paymentType: string,
  isSplit: OrderType ,
  isBusiness?: number,
  page: number,
  pageSize: number,
}
export const myPendingOrderList = (data: Params) =>
request({
    url: "/Api/Market/BusinessPendingOrder/myPendingOrderList",
    method: "GET",
    data,
  });

// /Api/User/Business/getOrderDetail 商家充值详情


export const getOrderDetail = (data: {orderNo: string}) =>
request({
    url: "/Api/User/Business/getOrderDetail",
    method: "POST",
    data,
  });